import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./AddMoreSection.module.css";

interface Props {
  onClick?: () => void;
  heading: string;
  text?: string;
}

const AddMoreSection = ({ onClick, heading, text }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <Text variant={"heading1"} color={"text"}>
        {heading}
      </Text>

      {text !== undefined && (
        <div className={styles.textArea} onClick={onClick}>
          {text}
        </div>
      )}
    </div>
  );
};

export default AddMoreSection;
